import { OperatorType } from 'constants/operators'
import * as Operator from 'components/operators'

export function operatorComponent(type: OperatorType) {
  return Operator[type]
}
